/** Paths shared by the still drawing and the animation, in the 451 x 451 artboard. */

export const CARD =
	'M288.754 255.746L269.929 103.333C269.147 97.2956 263.753 92.9349 257.673 93.4333L107.177 105.686C100.752 106.213 96.0395 111.945 96.7689 118.337L115.225 279.855';

/** The edge the thumb covers once the card is held. */
export const CARD_BOTTOM =
	'L116.36 289.79Q117.15 296.75 124.13 296.18L285.08 283.07Q292.06 282.51 291.2 275.56L288.754 255.746';

export const HEART =
	'M141.79 141.411C162.328 125.9 183.106 144.569 190.29 152.26C191.763 153.842 194.244 153.923 195.827 152.457C216.841 133.04 234.433 138.071 243.176 142.911C247.629 145.374 250.988 149.366 252.769 154.129C260.125 173.858 244.227 197.108 227.715 214.493L217.57 224.916C208.39 233.067 199.014 239.886 195.184 242.598C193.831 243.557 192.027 243.561 190.659 242.617C141.578 208.695 114.269 162.199 141.794 141.411H141.79Z';

export const CUFF =
	'M398.207 305.342L376.789 282.782C374.098 279.984 369.679 279.821 366.783 282.408L282.632 357.661C279.539 360.426 279.405 365.222 282.335 368.155L303.083 389.455C305.764 392.139 310.068 392.287 312.926 389.795L397.747 315.808C400.859 313.096 401.065 308.328 398.202 305.352L398.207 305.342Z';

/** The sparkles' paths, the centres they pop about, and the seconds of each endless twinkle, apart so they never pulse together. */
export const SPARKLE_ART = [
	{
		centre: '293.108 83.281',
		twinkle: 2.6,
		d: 'M293.108 61V78.1648M293.108 88.7617V105.931M271.345 83.2812H288.534M298.045 83.2812H315.238',
	},
	{
		centre: '71.768 204.492',
		twinkle: 3.1,
		d: 'M71.7679 182.211V199.38M71.7679 209.969V227.138M50.0001 204.492H67.1937M76.7056 204.492H93.8945',
	},
] as const;
